module.exports = __webpack_public_path__ + "static/face-filter-c8c740f730c6b32c6c70c94d61c9c001.mp4";